import Vue from 'vue';

const mutations = {
  /**
   * Set the groups property on state
   * with groups parameter.
   *
   * @param state
   * @param groups
   */
  setGroups(state, groups) {
    state.groups = groups;
  },

  /**
   * Set the queries property to a group.
   *
   * @param state
   * @param id
   * @param details
   */
  setQueriesInAGroup(state, { id, queries }) {
    const index = state.groups.data.findIndex((group) => group.id === id);

    Vue.set(state.groups.data[index], 'queries', queries);
  },

  setQueryResult(state, { groupId, id, data }) {
    const groupIndex = state.groups.data.findIndex((group) => group.id === groupId);
    const index = state.groups.data[groupIndex].queries.findIndex((query) => query.id === id);

    Vue.set(state.groups.data[groupIndex].queries[index], 'data', data);
  },

  setBatchInAGroup(state, batchResumes) {
    state.batchResumes = batchResumes;
  },

  /**
   * Set the availableCosnultations property on state
   * with availableConsultations prop.
   *
   * @param state
   * @param availableConsultations
   */
  setAvailableConsultations(state, availableConsultations) {
    state.availableConsultations = availableConsultations;
  },

  setAvailableTemplates(state, availableTemplates) {
    state.availableTemplates = availableTemplates;
  },

  /**
   * Set the documents property on state
   * with documents parameter.
   *
   * @param state
   * @param documents
   */
  setDocuments(state, documents) {
    state.documents = documents;
  },
};

export default mutations;
